import { render, staticRenderFns } from "./tipToSetSignPwd.vue?vue&type=template&id=7c47fef6"
import script from "./tipToSetSignPwd.vue?vue&type=script&lang=js"
export * from "./tipToSetSignPwd.vue?vue&type=script&lang=js"
import style0 from "./tipToSetSignPwd.vue?vue&type=style&index=0&id=7c47fef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports